import CopyIcon from 'icons/copy.svg?react';
import { toast } from 'material-react-toastify';

import { Text } from '@/components/shared/Text/Text';

interface EmailCopyFieldProps {
  userEmail: string;
}

const EmailCopyField = ({ userEmail }: EmailCopyFieldProps) => {
  return (
    <div className="grid grid-cols-[1fr,2fr,0.5fr] items-center py-2 font-medium">
      <Text.Regular weight="bold">{'Email'}</Text.Regular>
      <Text.Normal>{userEmail}</Text.Normal>
      <CopyIcon
        onClick={() => {
          navigator.clipboard.writeText(userEmail);
          toast.info('Email copied to clipboard');
        }}
        className="cursor-pointer ml-auto"
      />
    </div>
  );
};

export default EmailCopyField;
